import React, { useContext } from 'react';
import { MenuItem, MenuList, Paper, Popover } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch } from 'react-redux';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PersonIcon from '@mui/icons-material/Person';
import SidebarThemeContext from '../../../../@coremat/CmtLayouts/SidebarThemeContext/SidebarThemeContext';
import { logout } from 'redux/Account/AccountAction';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  userInfo: {
    paddingTop: 0,
    transition: 'all 0.1s ease',
    opacity: 1,
    '.Cmt-miniLayout .Cmt-sidebar-content:not(:hover) &': {
      height: 0,
      paddingTop: 0,
      opacity: 0,
      transition: 'all 0.3s ease',
    },
  },
  userTitle: {
    color: props => props.sidebarTheme.textDarkColor,
    marginBottom: 8,
  },
  userSubTitle: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    letterSpacing: 0.25,
  },
  centerFab: {
    marginLeft: '-4px',
    marginTop: 4,
    marginRight: 10,
  },
  centerFabNotOpened: {},
}));

const SidebarHeader = ({ isSidebarOpen }) => {
  const history = useHistory();
  const { sidebarTheme } = useContext(SidebarThemeContext);
  const { t } = useTranslation();
  const classes = useStyles({ sidebarTheme });

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const onLogoutClick = () => {
    handlePopoverClose();
    dispatch(logout());
  };

  const onProfileClick = () => {
    handlePopoverClose();
    history.push('/dealer/profile');
  };

  return (
    <div className={isSidebarOpen ? classes.rootWithFlex : classes.root} id="left-menu-root">
      {open && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          container={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
          style={{ zIndex: 10000 }}
          transformOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}>
          <Paper elevation={24} variant="outlined" style={{ zIndex: 10000 }}>
            <MenuList>
              <MenuItem onClick={onProfileClick}>
                <PersonIcon />
                <div className="ml-2">{t('popup.profile')}</div>
              </MenuItem>

              <MenuItem onClick={onLogoutClick}>
                <ExitToAppIcon />
                <div className="ml-2">{t('popup.logout')}</div>
              </MenuItem>
            </MenuList>
          </Paper>
        </Popover>
      )}
    </div>
  );
};

export default SidebarHeader;
